// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/NotFoundPage/NotFoundPage.jsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/NotFoundPage/NotFoundPage.jsx");
  import.meta.hot.lastModified = "1692612803108.5146";
}
// REMIX HMR END

import { Card, EmptyState, Page } from "@shopify/polaris";
import notFoundImage from "./empty-state.svg";
export function NotFoundPage() {
  return <Page>
      <Card>
        <EmptyState heading="There is no page at this address" image={notFoundImage}>
          <p>
            Check the URL and try again, or use the search bar to find what you
            need.
          </p>
        </EmptyState>
      </Card>
    </Page>;
}
_c = NotFoundPage;
var _c;
$RefreshReg$(_c, "NotFoundPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;